'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = 'vue-auth-cognito';

var AUTHENTICATE = exports.AUTHENTICATE = prefix + '/AUTHENTICATE';
var ATTRIBUTES = exports.ATTRIBUTES = prefix + '/ATTRIBUTES';
var SIGNOUT = exports.SIGNOUT = prefix + '/SIGNOUT';
var COGNITOUSER = exports.COGNITOUSER = prefix + '/COGNITOUSER';
var REMOVECOGNITOUSER = exports.REMOVECOGNITOUSER = prefix + '/REMOVECOGNITOUSER';


//////////////////
// WEBPACK FOOTER
// ./~/@smart/vue-auth-cognito/lib/mutation-types.js
// module id = aTyr
// module chunks = 0